<div class="callout-group">
  <swiper-container
    slides-per-column-fill="row"
    slides-per-view="1"
    space-between="16"
    (swiperinit)="onSwiper($event)"
    >
    @for (item of items | async; track item; let i = $index) {
      <swiper-slide>
        <app-generic-callout
          [head]="item.title"
          [subhead]="item.description"
          [image]="item.imageUrl"
          [link]="item.link"
          color="light"
          [side]="getSide(i)"
        ></app-generic-callout>
      </swiper-slide>
    }
  </swiper-container>
  @if (swiper?.activeIndex != 0) {
    <button
      (click)="navigateTo(swiper.activeIndex - 1)"
      class="prev-btn"
      >
      <app-slider-arrow-icon direction="left"></app-slider-arrow-icon>
    </button>
  }
  @if (!swiper?.isEnd) {
    <button
      (click)="navigateTo(swiper.activeIndex + 1)"
      class="next-btn"
      >
      <app-slider-arrow-icon direction="right"></app-slider-arrow-icon>
    </button>
  }
</div>
<div class="pagination">
  @for (x of groupNumbers; track x; let i = $index) {
    <div
      class="indicator"
      [ngClass]="{ on: i == swiper?.activeIndex }"
      (click)="navigateTo(i)"
    ></div>
  }
</div>
